import { Component, Element, Event, EventEmitter, h, Host, Prop } from "@stencil/core";
import { limitSlotElements } from "../../../utils/limitSlotElements";

@Component({
    tag: "ux-table-header-neo",
    shadow: true,
    styleUrl: "table-header-neo.scss"
})
export class TableBodyNeo {
    @Element() host!: HTMLUxTableHeaderNeoElement;

    /**
     *  If true, the header will stick to the top of the table when scrolling.
     */
    @Prop({ reflect: true }) readonly sticky: boolean;

    componentDidLoad() {
        limitSlotElements(this.host, {
            allowed: {
                default: ["ux-table-row-neo"]
            }
        });
    }

    /**
     *
     */
    @Event() cellCountChange!: EventEmitter<number>;

    private handleSlotChange(e: HTMLSlotElement | null) {
        if (!e) {
            return;
        }
        const nodes = (e as HTMLSlotElement).assignedNodes().filter((item) => item.nodeName.toLowerCase() !== "#text");
        this.cellCountChange.emit(nodes.length);
    }

    render() {
        return (
            <Host>
                <slot onSlotchange={(e) => this.handleSlotChange(e.target as HTMLSlotElement)} />
            </Host>
        );
    }
}
